module.exports = __webpack_public_path__ + "img/help-bg.00662d26.png";